var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAACEUlEQVRoQ+2YPU4CQRiGZ3ahMdFAIv50FECwwxvICfQIStaEEk8AnkBsjFGCegNuAJ5AShQLChNjgEhiQaIw424hQVhhZtgPRvJtQsN+f+/7zGZnlpIlveiS6iIo7L+RRWJITBMHcClqAkJ4DCQmbJUmga7EoqnWIadk3359BzSZ888xKCN39eL67WjAmLC41dzrc1LWXdDwfKa/l6xdbleG/xsTFrPecpwb2f8kjFJ2+lTYzE0UFk/bxL6WkJij2nnGCOH2T+/LMFiHMbMk9IzpLUV8OnyPiXulRyQS04OD+BRITNwrPSKRmBuH6PFLwuQm2Ea5Vvi9/5NZC0rEEunXcPfTLDNKwzLNZGMp542VNf9uNR/sSOfKJgy2XJTfqOTK5nDaP3kubOVl85SIRax2hnJ2JttMKZ7TI7e94LRaSsISmfdA94M9MMJglyIxGsaqkazlg41pQkbvKwn7KeIccWQbisb3DV+nfhGsisZ7Kky16TzyZiI2jwFVe6AwVecWlYfEFuW8al8kpurcovJAiEVS7SwxuNDL26Ss9Hi9ce61AZ4LU9lHun3JnVUogLBW2T5uCNEaDM/Jfb0YksuZotxzYTGraX/7J1Lf/lWPJpO0eS7MabZjH2t6jB2ILCfTRyq1q1BOJFYmBkSYzABQsSgMylmoukgMylmoukgMylmoukgMylmoukgMylmout/YToI3olh5xwAAAABJRU5ErkJggg==",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersign);
export default __webpack_public_path__ + "static/media/filtersign.f0f44273a4cca2debf4f7c0a18e14e40.svg";
export { ForwardRef as ReactComponent };